import { useMemo } from 'react';
import { useTokens } from './useTokens';
import { UNIFIED_TOKENS } from '@/constants';

export function useToken(id?: string | null, network?: string | null) {
  const tokens = useTokens();

  return useMemo(() => {
    if (id?.includes(':')) {
      return tokens?.find((token) => token.id === id);
    }

    for (const unified of UNIFIED_TOKENS) {
      if (unified.id === id) {
        const token = network
          ? unified.tokens.find((token) => token.network === network)
          : unified.tokens[0];

        if (!token) {
          return undefined;
        }

        return tokens?.find(
          ({ token_address, network }) =>
            token_address === token.token_address && network === token.network
        );
      }
    }

    return tokens?.find((token) => token.id === id);
  }, [tokens, id, network]);
}
